export * from './lib/next-link-composed';
